import { useState } from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Shield, Check, ArrowRight } from "lucide-react";
import { Button } from "../ui/button";

const ANON_SECTIONS = ["s1", "s2", "s3", "s4", "s5", "s6", "s7", "s8", "s9"];
const TRACKING_SECTIONS = ["s1", "s2", "s3", "s4", "s5", "s6", "s7", "s8", "s9", "s10"];
const MA_ALCADA_SECTIONS = ["s1", "s2", "s3", "s4", "s5", "s6", "s7", "s8", "s9", "s10"];

export function RGPDVoterAcceptance({ entityName, entityEmail, onAccepted, variant = "anonymous" }) {
  const { t } = useTranslation();
  const [accepted, setAccepted] = useState(false);

  const prefix = variant === "maAlcada" ? "rgpdMaAlcada" : variant === "tracking" ? "rgpdTracking" : "rgpdVoter";
  const sections = variant === "maAlcada" ? MA_ALCADA_SECTIONS : variant === "tracking" ? TRACKING_SECTIONS : ANON_SECTIONS;

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} data-testid="rgpd-voter-step">
      <div className="bg-white border border-slate-200 rounded-xl p-6 mb-6">
        <div className="flex items-center gap-3 mb-4">
          <Shield className="h-6 w-6 text-blue-600" />
          <div>
            <h3 className="text-lg font-bold text-slate-900">{t(`${prefix}.title`)}</h3>
            <p className="text-sm text-slate-500">{t(`${prefix}.subtitle`)}</p>
          </div>
        </div>

        <div className="max-h-[400px] overflow-y-auto border border-slate-200 rounded-lg p-5 bg-slate-50 space-y-4 text-sm text-slate-700 leading-relaxed"
             data-testid="rgpd-voter-content">
          {sections.map((s) => (
            <div key={s}>
              <p className="font-semibold text-slate-900">{t(`${prefix}.${s}_title`)}</p>
              <p dangerouslySetInnerHTML={{ __html: t(`${prefix}.${s}_text`, { entityName: entityName || "", entityEmail: entityEmail || "" }) }} />
            </div>
          ))}
        </div>

        <div className="mt-5 border border-slate-200 rounded-lg p-4 bg-white">
          <label className="flex items-start gap-3 cursor-pointer select-none" data-testid="rgpd-voter-checkbox-label">
            <input
              type="checkbox"
              checked={accepted}
              onChange={(e) => setAccepted(e.target.checked)}
              className="mt-1 h-4 w-4 rounded border-slate-400 text-blue-600 focus:ring-blue-500"
              data-testid="rgpd-voter-checkbox"
            />
            <span className="text-sm text-slate-700">{t(`${prefix}.accept`)}</span>
          </label>
        </div>

        <div className="mt-4 flex justify-end">
          <Button
            onClick={onAccepted}
            disabled={!accepted}
            className="bg-blue-600 hover:bg-blue-700 text-white disabled:opacity-50"
            data-testid="rgpd-voter-accept-btn"
          >
            <Check className="h-4 w-4 mr-2" />
            {t(`${prefix}.continue`)}
            <ArrowRight className="h-4 w-4 ml-2" />
          </Button>
        </div>
      </div>
    </motion.div>
  );
}
